import React from 'react'
import { useIdleTimer } from 'react-idle-timer'

export const IdleTimerLocal = ()=>{
    const onIdle = ()=>{
		const event  = new Event("fiosReferralIdleTimeout")
        window.dispatchEvent(event)
	}
	const { getRemainingTime } = useIdleTimer({
		onIdle,
		timeout: 45000,
		throttle: 500
	  })
      return(
        <div>

        </div>
      )
}